export default __webpack_public_path__ + "static/media/Texting 3.5359350f.jpeg";